<template>
  <div class="nlp__main-box">
    <h1> Detect Dirty <span>Crypto</span> in Seconds </h1>
    <p>
      Just paste a crypto address, and Satoshi Eye will quickly check the risks
      and provide a clear report.
    </p>
    <NlpSearchBar parent-block="main" />
    <div class="nlp__main-box-or">
      OR
    </div>
    <div
      class="nlp__main-box--example"
      @click="goToReport({ type: 'full' })"
    >
      <gl-icon
        :height="24"
        name="example-arrow"
        :width="24"
      />
      View Report Example
    </div>
  </div>
</template>

<script>
// Components
import NlpSearchBar from '@/pages/landing-page/components/NlpSearchBar.vue'
import GlIcon from '@/components/gl-icon'
// utils
import { openExample } from '@/utils/go-to-route'

export default {
  name: 'NlpMain',
  components: {
    NlpSearchBar,
    GlIcon,
  },
  methods: {
    openExample,
    goToReport({ type }) {
      this.openExample(type)
    },
  },
}
</script>

<style scoped>
.nlp__main-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 206px;
  padding-bottom: 200px;
}
.nlp__main-box h1 {
  max-width: 574px;
  margin-bottom: 16px;
  text-align: center;
}
.nlp__main-box p {
  max-width: 528px;
  margin-bottom: 32px;
  text-align: center;
}

.nlp__main-box-or {
  color: var(--Grey, #5a627d);
  font-size: 18px;
  font-weight: 400;
  line-height: 26px;
  margin: 16px 0;
}

.nlp__main-box--example {
  cursor: pointer;
  display: inline-flex;
  height: 40px;
  padding: 0 16px 0 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  border-radius: 100px;
  border: 1px solid var(--White, #fff);
  background: #f4f6f9;
  box-shadow: 0 24px 24px -12px rgba(14, 63, 126, 0.04),
    0 6px 6px -3px rgba(42, 51, 70, 0.04),
    0 3px 3px -1.5px rgba(42, 51, 70, 0.08),
    0 1px 1px -0.5px rgba(42, 51, 69, 0.04);
}

@media (max-width: 1279px) {
  .nlp__main-box {
    padding-top: 260px;
    padding-bottom: 280px;
  }
}
@media (max-width: 767px) {
  .nlp__main-box {
    padding-top: 140px;
    padding-bottom: 136px;
  }
}
</style>
